import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
} from '@chakra-ui/react';
import React from 'react';

interface ActionProps {
  text: string;
  action?: () => void;
  isLoading?: boolean;
  disabled?: boolean;
}

interface ConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  content: React.ReactNode;
  primary?: ActionProps;
  secondary?: ActionProps;
  buttonColorScheme?: string;
  headerColor?: string;
  headerTextColor?: string;
  closeButtonExist?: boolean;
  closeOnOverlayClick?: boolean;
}

export const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  onClose,
  title,
  content,
  primary = { text: 'OK' },
  secondary = { text: 'Cancel' },
  buttonColorScheme = 'red',
  headerColor = 'red.500',
  headerTextColor = 'white',
  closeButtonExist = true,
  closeOnOverlayClick = true,
}) => {
  console.info('confirm-modal.tsx_1');

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      closeOnOverlayClick={closeOnOverlayClick}
    >
      <ModalOverlay bg="rgba(0, 0, 0, 0.3)" />
      <ModalContent>
        <ModalHeader bg={headerColor} color={headerTextColor}>
          {title}
        </ModalHeader>
        {closeButtonExist || (primary.isLoading && <ModalCloseButton />)}
        <ModalBody>{content}</ModalBody>
        <ModalFooter>
          {primary.isLoading ? null : (
            <Button
              variant={'outline'}
              onClick={secondary.action || onClose}
              mr={5}
              disabled={secondary.disabled}
            >
              {secondary.text}
            </Button>
          )}
          {primary.action && (
            <Button
              isLoading={primary.isLoading}
              colorScheme={buttonColorScheme}
              onClick={primary.isLoading ? undefined : primary.action}
              disabled={primary.disabled}
            >
              {primary.text}
            </Button>
          )}
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
